import React from "react";
import { Link } from "react-router-dom";
import "./subMenuItem.scss";

const SubMenuItem = ({ menuItems, showMenuItem, permissionsArr }) => {
    return (
        <div className={showMenuItem ? "sub-menu sub-menu-active" : "sub-menu"}>
            {menuItems.map((menuItem) => {
                if (permissionsArr.includes(menuItem.permission) || permissionsArr.includes("all")) {
                    return (
                        <Link className="sub-menu__item" to={menuItem.link} key={menuItem.name}>
                            {menuItem.name}
                        </Link>
                    );
                }
            })}
        </div>
    );
};

export default SubMenuItem;
